/**
 * Модуль сабмита формы новорожденного
 */
itsoftApp.createModule('submitForm', function () {
  // Локальные переменные
  let module = this;

  function sendData(url = '', form) {
    const formData = new FormData(form);
    
    const xhr = new XMLHttpRequest();

    xhr.open('POST', url);

    xhr.send(formData)

    xhr.onload = function() {
      if (xhr.status != 200) { // анализируем HTTP-статус ответа, если статус не 200, то произошла ошибка
        console.warn(`Ошибка ${xhr.status}: ${xhr.statusText}`); // Например, 404: Not Found
      } else { // если всё прошло гладко, выводим результат
        console.log(`Готово, получили ${xhr.response.length} байт`); // response -- это ответ сервера
      }
    };
  }

  const submitForm = function () {
    const form = document.getElementById('form-babies-born');
    const popupForm = document.getElementById('baby-born-form');
    const popupCode = document.getElementById('baby-born-code');
    let url;

    if (form) {
      const policyCheckbox = form.querySelector('#born-form-policy');
      url = form.getAttribute('action');

      form.addEventListener('submit', event => {
        event.preventDefault();
        let isSubmit = true;

        // Проверка на чек-бокс о политике данных
        if (policyCheckbox && policyCheckbox.checked) {
          policyCheckbox.closest('.input-wrapper').classList.remove('error');
        } else {
          policyCheckbox.closest('.input-wrapper').classList.add('error');
          isSubmit = false;
        }

        // Проверка на инпуты о днях рождения

        const inputsBorn = form.querySelectorAll('.js-flatpicker-date');

        inputsBorn.forEach(input => {
          if (input.value === '') {
            input.classList.add('error');
            isSubmit = false;
          } else {
            input.classList.remove('error');
          }
        });

        if (isSubmit) {
          if (popupForm && popupForm) {
            popupForm.dispatchEvent(closeEvent);
            popupCode.dispatchEvent(openEvent);
            let date = new Date(Date.now() + 86400e3).toUTCString();
            document.cookie = "hideForAllPages=true; path=/; expires=" + date;
            itsoftApp.modules.closeBornWidget.callbacks.hideWidget();

            sendData(url, form);
          }
        }
      });
    }
  };

  submitForm();
  module.callback = submitForm;
});
